import(/* webpackMode: "eager" */ "/app/app/firms/SkeletonGroup.jsx")